import type { FunctionComponent } from 'react'
import React from 'react'

import classes from './CryingChild.module.scss'

/** The crying child in a circle, the face of a page that went wrong for the visitor. */
export const CryingChild: FunctionComponent = () => (
  <div aria-hidden className={classes.portrait}>
    <div className={classes.photo} />
  </div>
)
